import { createFileRoute } from "@tanstack/react-router";

import { Accounts } from "@/features/admin";

export const Route = createFileRoute("/admin/")({
  component: Accounts,
});
